<template>
  <div>
    <div class="top">
      <img class="picimg" src="@/assets/images/关于我们-头图.jpg" />
    </div>
    <div style="display: flex; align-items: center" class="prompt">
      <img class="icon" src="@/assets/images/zhuye.png" />
      <span class="color858"
        >&nbsp;&nbsp;你现在的位置&nbsp;&nbsp;/&nbsp;&nbsp;首页&nbsp;&nbsp;/&nbsp;&nbsp;</span
      >
      <span>关于我们</span>
    </div>
    <div class="main">
      <div class="btn">
        <el-button plain v-if="flag" class="border2">公司简介</el-button>
        <el-button plain v-if="!flag" @click="handleClick('1')"
          >公司简介</el-button
        >
        <el-button plain @click="handleClick('3')">公司荣誉</el-button>
        <el-button plain @click="handleClick('5')">企业文化</el-button>
      </div>
      <div class="module1" v-show="type == '1'">
        <div class="box1">
          <p>
            湖北毅瑞数据科技有限公司成立于2020年5月，是一家扎根湖北武汉、深耕BIM技术、数字孪生技术、数字智能化领域的高新技术服务企业，以智慧街区数字化场景解决方案服务商、景区智能化全场景解决方案服务商、BIM全过程应用服务商、数字孪生模型服务商为核心定位，专注为智慧街区、文旅景区、政企单体等提供全场景数字化解决方案与全周期技术服务。
          </p>
          <p>
            公司以“数智赋能产业，技术服务实体”为核心发展理念，依托数字孪生、BIM技术等核心能力，融合物联网、AI、大数据等前沿技术，打造了从平台升级、定制开发、部署实施到运营维护的全栈服务能力，为智慧街区、文旅景区打造集智能感知、数据融合、智慧管控、场景服务于一体的数字化运营体系，全面破解传统领域中信息孤岛、管理低效、体验单一等行业痛点，助力客户实现数字化、智能化、精细化升级。
          </p>
        </div>
        <div style="width: 60%">
          <img class="usImage" src="@/assets/image/gongsi.png" />
        </div>
      </div>
      <div class="module3" v-show="type == '3'">
        <div class="honorRow">
          <div class="honor1">
            <img
              src="@/assets/image/CompanyHonors.png"
              alt="CompanyHonors"
            />
          </div>
        </div>
      </div>
      <div class="module2" v-show="type == '5'">
        <img class="usImage" src="@/assets/image/企业愿景.jpg" />
      </div>
    </div>

    <Bottom />
    <Right />
  </div>
</template>

<script>
import Bottom from "./bottom.vue";
import Right from "./right.vue";
export default {
  components: {
    Bottom,
    Right,
  },
  data() {
    return {
      type: "1",
      flag: true,
    };
  },
  methods: {
    handleClick(val) {
      this.flag = false;
      this.type = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  padding: 60px 400px;
  box-sizing: border-box;
  .btn {
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
    .el-button {
      width: 220px;
      height: 60px;
      font-size: 18px;
      background-color: #eee;
      margin: 0 20px;
    }
  }
  .module1 {
    display: flex;
    justify-content: center;
  }
  .module2 {
    width: 80%;
    margin: auto;
  }
  .module3 {
    width: 90%;
    margin: auto;
    .honor1 {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 750px;
        height: 520px;
        object-fit: contain;
        max-width: 100%;
        margin: 0;
      }
    }
    .honorRow {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 30px 0 0;
    }
  }
  .module4 {
    width: 50%;
    margin: auto;
  }
  .usImage {
    width: 100%;
    object-fit: cover;
  }
}
</style>
